import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { NEGATIVE_IR_BALANCE_HINT } from 'helpers/i18n.jsx'
import {
    LACK,
    DESCRIPTION,
} from './constants.jsx'

import styles from './LackOfIndustrialResource.scss'

export const LackOfIndustrialResource = (props) => {
    return (
        <div className={styles.base}>
            <div className={styles.lack}>
                {LACK(props.resource)}
            </div>
            <div className={styles.description}>
                {
                    (props.industrialResourceAvailable < 0) ?
                        NEGATIVE_IR_BALANCE_HINT :
                        DESCRIPTION
                }
            </div>
        </div>
    )
}

LackOfIndustrialResource.propTypes = {
    resource: PropTypes.node.isRequired,
    industrialResourceAvailable: PropTypes.number.isRequired,
}

export const mapStateToProps = (state) => ({
    industrialResourceAvailable: state.clan.industrial_resource,
})

export default connect(mapStateToProps, null)(LackOfIndustrialResource)


// WEBPACK FOOTER //
// ./components/LackOfIndustrialResource/LackOfIndustrialResource.jsx